import React, { useEffect, useRef } from "react";

/** textarea 높이 계산 @author c_bae */
const calculateTextareaAutoHeight = (textarea: HTMLTextAreaElement) => {
  const cursorPosition = textarea.selectionStart;
  const textBeforeCursor = textarea.value.substring(0, cursorPosition);
  const textAfterCursor = textarea.value.substring(cursorPosition);
  const isFirstLine =
    !textBeforeCursor.includes("\n") && textAfterCursor.trim().length === 0;

  if (isFirstLine) {
    textarea.style.height = "100%";
    textarea.value = textBeforeCursor; // 첫번째 라인이라고 판단되면 커서 앞에 있는 값만 남기고 모두 제거
  } else {
    textarea.style.height = "auto"; // 해당 코드 없으면 개행될때마다 텍스트가 움직임
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
};

const useAutoHeightTextArea = (
  value: string,
  onValueChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = textareaRef.current;

    if (!textarea) {
      return false;
    }

    onValueChange(e);
  };

  useEffect(() => {
    /** selectedDatasetCurrent 바뀌면 높이 재계산 @author c_bae */
    textareaRef.current && calculateTextareaAutoHeight(textareaRef?.current);
  }, [value.split(/\r?\n/).length]);

  return {
    textareaRef,
    handleTextareaChange,
  };
};

export default useAutoHeightTextArea;
